export { AgentHomeNavProvider, useIsAgentHomeNav } from './agent-home-nav-context';
export { AgentHomePanel } from './agent-home-panel';
export {
  agentHomePanelCollapsedPreferenceAtom,
  agentHomePanelOpenAtom,
  isAgentHomeActive,
  isAgentHomeLandingAtom,
  isAgentHomeProjectChat,
  isAgentHomeRailActive,
  shouldShowAgentHomePanel,
  syncAgentHomePanelFromPreference,
  useAgentHomePanel,
  useAgentHomePanelPreferenceSync,
} from './agent-home-panel-state';
export { AgentHomePanelToggle } from './agent-home-panel-toggle';
export { NavV3 } from './nav-v3';
export { navV3Messages } from './nav-v3.messages';
export { ObjectWorkspaceChatHarness } from './object-workspace/object-workspace-chat-harness';
export type { ObjectWorkspaceChatLifecycleReport } from './object-workspace/object-workspace-chat-harness';
export {
  getPatientObjectWorkspaceRoute,
  getVisitObjectWorkspaceRoute,
  navigateToWorkHomeState,
  shouldHoldObjectWorkspaceNavigation,
  workHomeObjectEntryGateAtom,
} from './object-workspace/object-workspace-navigation';
export { ObjectWorkspaceRouteSurface } from './object-workspace/object-workspace-route-surface';
